import { pushModal } from '../Modals/redux/basicActions';
import { ModalType } from '../Modals/redux/types';

export const pushVerificationSuccessfulPopup = () =>
  pushModal(ModalType.VERIFICATION_SUCCESSFUL, {
    wrapInModal: false,
  });
